import {Controller} from "stimulus"

/*
 * Removes its element from the page when the user cancels out of it, e.g. an
 * inline form that a turbo stream rendered into a container.
 */
export default class extends Controller {
  dismiss() {
    this.element.remove()
  }
}
